import global from '@components'
import ChargeRoomForm from './charge-room-form/charge-room-form'
import GuestForm from './guest-form/guest-form'
import AccessCodeForm from './access-code-form/access-code-form'
import UpgradeWifiForm from './upgrade-wifi-form/upgrade-wifi-form'
import Connecting from './connecting/connecting'
import LanguageSelectorHsia from './language-selector-hsia/language-selector-hsia'

export default {
  ...global,
  ChargeRoomForm,
  GuestForm,
  AccessCodeForm,
  UpgradeWifiForm,
  Connecting,
  LanguageSelectorHsia,
}
